import React from 'react';
import styled from 'styled-components';

const StyledFooter = styled.div`
  margin-top: 25px;
  padding: 0.5em 2em;
  background: var(--primary);
  width: 100%;
  color: var(--white);
  display: flex;
  justify-content: space-between;
  @media (max-width: 576px) {
    flex-direction: column;
    justify-content: center;
    text-align: center;
    div + div {
      margin-top: 1em;
    }
  }
`;
const Link = styled.a`
  display: inline-block;
  font-weight: bold;
  color: var(--white);
  &:hover {
    text-decoration: none;
  }
`;

const Footer = () => {
  return (
    <StyledFooter>
      <div>v0.8.2 💉🦠</div>
      <div>
        Máte otázku/návrh? Email:{' '}
        <Link href="mailto:cakaren.data@gmail.com">cakaren.data@gmail.com</Link>
      </div>
      <div>
        Zdroj dát{' '}
        <Link
          href="https://github.com/Institut-Zdravotnych-Analyz/covid19-data"
          target="_blank"
        >
          IZA
        </Link>
      </div>
    </StyledFooter>
  );
};

export default Footer;
